import React from 'react';

import styles from './styles.module.scss';

const ColumnContainer = ({
  disclaimer,
  title,
  titleDescription,
  smallIcon,
  headerRight,
  isCommingSoon,
  children
}) => {
  return (
    <div className={styles.column}>
      <div className={styles.titleContainer}>
        <h3 className={styles.columnTitle}>
          {smallIcon}

          {disclaimer && (
            <span className={styles.disclaimer}>{disclaimer}</span>
          )}
          {title || ''}
          <span className={styles.titleBold}>{titleDescription || ''}</span>
          {headerRight && (
            <div className={styles.headerRightAction}>{headerRight}</div>
          )}
        </h3>

        {isCommingSoon && <span className={styles.soonLabel}>Coming Soon</span>}
      </div>
      <div className={styles.cardWrapper}>
        <div className={styles.card}>{children}</div>
      </div>
    </div>
  );
};

export default ColumnContainer;
